import PreviewMap from '../PreviewMap';
import PreviewButton from '../PreviewButton';
export default {
    MAP: PreviewMap,
    BUTTON: PreviewButton,
};
